import { Maybe } from '@tapestry/shared/graphql';

export const getInitials = (
  firstName: Maybe<string> | undefined,
  lastName: Maybe<string> | undefined
) => {
  return `${firstName?.charAt(0)}${lastName?.charAt(0)}`;
};
